var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('v-chip',{attrs:{"close":""},on:{"click:close":_vm.unselect_model}},[_vm._v(_vm._s(_vm.model.name))])],1),(_vm.job && _vm.job.processed !== 1)?_c('td',[_vm._v(_vm._s(_vm.$t('most_c.calculating'))+" "),_c('job-progess-bar',{attrs:{"job":_vm.job}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }